import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=38ca5820&scoped=true&"
var script = {}
import style0 from "./welcome.vue?vue&type=style&index=0&id=38ca5820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca5820",
  null
  
)

export default component.exports